import React, { useState, useEffect, useRef } from 'react';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Password } from 'primereact/password';
import { storage } from '../../helpers/storage';


const initialForm = {
    usuario: "",
    nombre: "",
    tipo_usuario: "",
    tienda: "",
    password_: ""
}

const validationsFrom = (form) => {
    let errors = {};
    let regexName = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/;
    //let regexEmail = /^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}$/;
    let regexEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
    //let regexComments = /^.{1,255}$/;
    let regexDigitos = /^.{1,10}$/;
    let regexNumbers = /^([0-9])*$/;

    //console.log(form);

    if (!form.nombre.trim()) {
        errors.nombre = "El Campo (Nombre completo) es requerido";
    }

    if (!form.usuario.trim()) {
        errors.usuario = "El Campo (Nombre de usuario) es requerido";
    }

    if (!form.tipo_usuario) {
        errors.tipo_usuario = "El Campo (Tipo de usuario) es requerido";
    }

    if(form.tipo_usuario === 13){
        if(!form.tienda){
            errors.tienda = "El Campo (Sede) es requerido"
        }
    }

    if (![1, 5].includes(parseInt(form.tipo_usuario))) {
        if (!form.tienda) {
            errors.tienda = "El Campo (Tienda) es requerido";
        }
    }

    return errors;
}

const Edit = ({ visible, user, close, onComponentUpdate, us }) => {

    const toast = useRef(null);

    const [form, setForm] = useState(initialForm);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState(null);
    const [getTiposUsuario, setTiposUsuario] = useState(null);
    const [getTiendas, setTiendas] = useState(null);
    const [getInputTienda, setInputTienda] = useState(false);
    const [tipoUsuario, setTipoUsuario] = useState(null);
    const perfil = storage.get("perfilid");

    useEffect(() => {
        if (user != null) {
            const EditForm = {
                usuario: user.Usuario,
                nombre: user.Nombre,
                tipo_usuario: user.IdTipoUsuario,
                tienda: (user.IdTienda === null ? 0 : user.IdTienda),
                password: user.Password
            }
            if (![1, 5].includes(parseInt(user.IdTipoUsuario))) {
                setInputTienda(true);
            } else {
                setInputTienda(false);
            }
            setForm(EditForm);
            setErrors(validationsFrom(EditForm));
        } else {
        }
    }, [user])

    const handleSubmit = (e) => {
        e.preventDefault();
        setErrors(validationsFrom(form));
        if (Object.keys(errors).length === 0) {
            const arrUser = {
                opcion: "M",
                IdUsuario: user.IdUsuario,
                Usuario: form.usuario,
                Nombre: form.nombre,
                Password: form.password,
                IdTipoUsuario: form.tipo_usuario,
                TipoPerfil: form.tipo_usuario,
                IdTienda: ([1, 5].includes(parseInt(form.tipo_usuario)) ? 0 : parseInt(form.tienda))
            };
            setLoading(true);
            helpHttp().post(`${BASE_API}Usuarios/EjecutarUsuarios`, {
                body: arrUser,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            })
                .then((res) => {
                    if (res.ITEMS !== null) {
                        let getTipoUsuario = getTiposUsuario.filter(el => el.code === arrUser.IdTipoUsuario);
                        // let getTienda = getTiendas.filter(el => el.IdTienda === arrUser.IdTienda);
                        const updateData = {
                            IdUsuario: user.IdUsuario,
                            Usuario: arrUser.Usuario,
                            Password: user.Password,
                            Nombre: arrUser.Nombre,
                            Activo: user.Activo,
                            IdTienda: parseInt(arrUser.IdTienda),
                            Tienda: arrUser.IdTienda,
                            IdTipoUsuario: user.IdTipoUsuario,
                            TipoUsuario: getTipoUsuario[0]?.name
                        }
                        showToast('success', 'Mensaje:', 'Usuario actualizado correctamente.');
                        close();
                        onComponentUpdate(updateData);
                        us(res.ITEMS)
                    } else {
                        showToast('info', 'Mensaje:', res.MESSAGE);
                        setLoading(false);
                        close();
                    }
                    setLoading(false);
                });
        } else {
            showToast('warn', 'Aviso:', 'Favor de llenar los campos requeridos.');
            return;
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({
            ...form,
            [name]: value,
        });
    };

    const handleBlur = (e) => {
        handleChange(e);
        setErrors(validationsFrom(form));
    };

    const showToast = (severity, summary, detail) => {
        toast.current.show({
            severity: severity,
            summary: summary,
            detail: detail,
            life: 5000
        });
    };

    let url = `${BASE_API}Dinamico/ConsultaDinamica`;

    useEffect(() => {
        helpHttp().post(url, {
            body: {
                sp: "spdTipoUsuariosObtener",
                tipo: 0,
                parametros: [
                    { idTipoUsuario: perfil }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {

            if (res.ITEMS !== null) {

                if (res.ITEMS.length > 0) {
                    setTiposUsuario(res.ITEMS);
                } else {
                    setTiposUsuario(null);
                }
                setLoading(false);
            }
        });
    }, [url]);

    let url2 = `${BASE_API}Usuarios/EjecutarTiendas`;

    useEffect(() => {
        setLoading(true);
        helpHttp().post(url2, {
            body: {
                "opcion": "O",
                "IdTienda": 0,
                "Tienda": "",
                "Activo": true
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            let jsonTiendas = res.ITEMS;

            if (jsonTiendas.length > 0) {

                setTiendas(jsonTiendas);
            } else {
                setTiendas(null);
            }
            setLoading(false);
        });
    }, [url2]);


    return (
        <>
            <Toast ref={toast} />

            <Dialog id="modalEditarUsuario" header="EDITAR USUARIO" breakpoints={{ '1000px': '90vw' }} draggable={false} closable={false} blockScroll={true} visible={ visible  } style={{ width: '33vw' }} modal onHide={ close }>
                <form onSubmit={handleSubmit} className="col-12">
                    <div className="div">
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12">
                                <label htmlFor="usuario">Nombre de usuario:</label>
                                <InputText id="usuario" disabled name="usuario" placeholder='Usuario para inicio de sesión' type="text" value={form.usuario} onChange={handleChange} onBlur={handleBlur} className={errors.usuario && 'p-invalid'} autoFocus />
                                {errors.usuario && <small className="p-error">{errors.usuario}</small>}
                            </div>
                            <div className="field col-12">
                                <label htmlFor="nombre">Nombre completo:</label>
                                <InputText id="nombre" placeholder='Nombre completo' disabled={(form.tipo_usuario == 13 || form.tipo_usuario == 16) && form.usuario.substring(0,2) == 26 ? true : false } name="nombre" type="text" value={form.nombre} onChange={handleChange} onBlur={handleBlur} className={errors.nombre && 'p-invalid'} />
                                {errors.nombre && <small className="p-error">{errors.nombre}</small>}
                            </div>
                            <div className="field col-12">
                                <label htmlFor="tipo_usuario">Tipo de usuario:</label>
                                <Dropdown id="tipo_usuario"  disabled={(form.tipo_usuario == 13 || form.tipo_usuario == 16) && form.usuario.substring(0,2) == 26 ? true : false } name="tipo_usuario" value={form.tipo_usuario} options={getTiposUsuario} optionLabel="name" optionValue='code' placeholder="Selecciona" onChange={handleChange} ></Dropdown>
                                {errors.tipo_usuario && <small className="p-error">{errors.tipo_usuario}</small>}
                            </div>
             
                            {((form.tipo_usuario == 13 && form.usuario.substring(0,2) != 26) && 
                                <div className="field col-12" id="div-tienda">
                                    <label htmlFor="tienda">Sede:</label>
                                    <select name="tienda" id="tienda" className={`form-select p-inputtext p-component`} value={form.tienda} onChange={handleChange} onBlur={handleBlur} style={{cursor: 'pointer'}}>
                                        <option value="">Selecciona</option>
                                        {getTiendas && getTiendas.map((el,index) => <option 
                                         value={el.IdTienda} key={index} >{el.Tienda}</option> )}
                                    </select>
                                    {errors.tienda && <small className="p-error">{errors.tienda}</small>}
                                </div>
                             )} 
                            
                            <div className="field col-12">
                                <label htmlFor="password_">Contraseña:</label>
                                <Password id="password" placeholder='Contraseña' toggleMask feedback={false} name="password" type="password" value={form.password} onChange={handleChange} onBlur={handleBlur} className={errors.password_ && 'p-invalid'} />
                                {errors.password_ && <small className="p-error">{errors.password_}</small>}
                            </div>
                        </div>
                        <div className="p-dialog-footer text-right" style={{ marginTop: '15px', paddingTop: '15px' }}>
                            <Button type='button' label="Cancelar" icon='pi pi-times' className="p-button-outlined mr-2 mb-2" onClick={close} />
                            <Button type='submit' disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-check')} label="Guardar" className="p-component mr-2 mb-2" />
                        </div>
                    </div>
                </form>
            </Dialog>
        </>
    );
}

export default Edit;